import React from 'react'
import Layout from '../../shared/components/organisms/layout/layout'
import PredictionSign from '../organisms/prediction-sign/prediction-sign';
import SEO from "../../shared/seo";
import { siteUrl } from '../../shared/utils/siteUrl';

const SignsTemplate = props => {
    // var mobile = typeof window !== "undefined" ? window.innerWidth < 1024 ? true : false : false
    // var news_info=props.dataProp
    const [isMobile, setMobileBool] = React.useState(false);
    // send active modal to layout
    const [modalActive, setModalActive] = React.useState(); 
    const updateDimensions = () => {
        setMobileBool(window.innerWidth < 1024 ? true : false);
    }
    React.useEffect(() => {
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => {
            window.removeEventListener("resize", updateDimensions);
        }
    }, [])

    return (
        <Layout
            mobile={isMobile}
            modalActive={modalActive}
            title={props.pageContext.params.metaTitulo} 
        >

            <SEO 
                title={props.pageContext.params.metaTitulo} 
                description={ props.pageContext.params.metaDescripcion.metaDescripcion.split("\n")[0]}
                image={"https:" + props.pageContext.params.imagenPrediccionDelDia?.file?.url}
                url={'/magazin/horoscopo/' + props.pageContext.slug}
            />
            <PredictionSign sign={props.pageContext.params} mobile={isMobile} setModalActive={setModalActive}/>
            
        </Layout>
    )
}

export default SignsTemplate;
